import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    changeTransaction,
    createTransaction,
    setEdit,
    setInActiveEditingTransaction,
} from "../features/transaction/transactionSlice";

const Form = () => {
    const [name, setName] = useState("");
    const [type, setType] = useState("income");
    const [amount, setAmount] = useState("");
    const dispatch = useDispatch();
    const { isLoading, isError, editMode, editingTransaction } = useSelector(
        (state) => state.transaction
    );

    const {
        id,
        name: editingTName,
        type: editingTType,
        amount: editingTAmount,
    } = editingTransaction || {};

    useEffect(() => {
        if (id) {
            setName(editingTName);
            setType(editingTType);
            setAmount(editingTAmount);
        } else {
            resetInputs();
        }
    }, [editingTransaction, editingTName, editingTType, editingTAmount, id]);

    const resetInputs = () => {
        setName("");
        setType("income");
        setAmount("");
    };

    const handleCreate = (e) => {
        e.preventDefault();

        dispatch(
            createTransaction({
                name,
                type,
                amount: Number(amount),
            })
        );

        resetInputs();
    };

    const handleUpdate = (e) => {
        e.preventDefault();

        dispatch(
            changeTransaction({
                id,
                data: {
                    name,
                    type,
                    amount,
                },
            })
        );

        dispatch(setEdit(false));
        dispatch(setInActiveEditingTransaction());
        resetInputs();
    };

    const handleCancelEdit = () => {
        resetInputs();
        dispatch(setEdit(false));
        dispatch(setInActiveEditingTransaction());
    };

    return (
        <div className="form">
            <h3>Add new transaction</h3>

            <form onSubmit={editMode ? handleUpdate : handleCreate}>
                <div className="form-group">
                    <label>Name</label>
                    <input
                        type="text"
                        name="name"
                        required
                        placeholder="enter title"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>

                <div className="form-group radio">
                    <label>Type</label>
                    <div className="radio_group">
                        <input
                            required
                            type="radio"
                            value="income"
                            name="type"
                            checked={type === "income"}
                            onChange={(e) => setType(e.target.value)}
                        />
                        <label>Income</label>
                    </div>
                    <div className="radio_group">
                        <input
                            type="radio"
                            value="expense"
                            name="type"
                            placeholder="Expense"
                            checked={type === "expense"}
                            onChange={(e) => setType(e.target.value)}
                        />
                        <label>Expense</label>
                    </div>
                </div>

                <div className="form-group">
                    <label>Amount</label>
                    <input
                        type="number"
                        placeholder="300"
                        required
                        name="amount"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                    />
                </div>

                <button
                    disabled={isLoading}
                    className="btn add_transaction_btn"
                    type="submit"
                >
                    {editMode ? "Update Transaction" : "Add Transaction"}
                </button>
            </form>

            {!isLoading && isError && (
                <p className="error">There was an error ocurred!</p>
            )}

            {editMode && (
                <button onClick={handleCancelEdit} className="btn cancel_edit">
                    Cancel Edit
                </button>
            )}
        </div>
    );
};

export default Form;
